import { render, staticRenderFns } from "./brokerage-view.vue?vue&type=template&id=146c6883&"
import script from "./brokerage-view.vue?vue&type=script&lang=js&"
export * from "./brokerage-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports